import _BaseAPIService from "./_BaseAPIService";

  const apiService = _BaseAPIService.instance;
const CountryIntelSectionService = {
  getList: async (id) => {
    const response = await apiService.get(`/destinationcountrywidgets/by-country-slug/${id}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await apiService.get(`/countrywiseintellsection/by-country/${id}`);
    return response.data;
  },
    
}

export default CountryIntelSectionService
